import { Input as AntdInput, Checkbox, Divider } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import Select from 'components/Form/Select'
import TreeSelect from 'components/TreeSelect'
import { RedText } from 'components/UIComponents/FormStyles'
import Toggle from 'components/UIComponents/Toggle'
import GreenStarIcon from 'components/icons/GreenStarIcon'
import GroupPeopleIcon from 'components/icons/GroupPeopleIcon'
import RoleStatus from 'modules/Roles/Partials/RolesTable/RoleStatus/index'
import {
  AddClgDiv,
  RatingFlex,
  ShortListCanDiv,
  ShortListDiv,
  ShortlistDiv,
  ShortlistFlex,
  ToggleDiv,
} from 'modules/Roles/ViewRole/DriveDrawers/Style/style'
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
import CustomRangeSlider from '../../../../../../components/CustomRangeSlider'
import { RoleNameDiv, ShortListFlex } from '../../../Style/style'

const RoleWrapper = styled.div`
  color: #808697;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
`
const DividerStyle = styled(Divider)`
  border-width: 1px;
  border-color: 1px solid rgb(230, 231, 234);
  margin-top: 28px;
  padding-bottom: 20px;
`
export const StyledGroup = styled(Checkbox.Group)`
  padding-top: 8px;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  .ant-checkbox-wrapper {
    color: #343e59 !important;
  }
  font-weight: 600;
`

const AntdInputStyle = styled(AntdInput)`
  ::placeholder {
    font-weight: ${FONT.FW_700};
    font-size: ${FONT.F_SM};
    color: ${COLORS.GREY_T_30};
    padding: 5px 10px;
    background: ${COLORS.GREY_T_95};
    padding-left: 20px;
  }
  width: 20%;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  height: ${props => (props.height ? props.height : '48px')};
  padding: ${props => (props.padding ? props.padding : '')};
  border-radius: 8px;
  box-shadow: none;
  border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
  :focus {
    border-color: #e9e9e9;
    box-shadow: none;
  }
  :hover {
    border-color: #e9e9e9;
  }
  :not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #e9e9e9 !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none;
    border-right-width: 0px !important;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`
const AddUserForm = ({
  applyFilter,
  setApplyFilter,

  errors,

  appliedCandidatesListTrue,
  setErrors,
  singleRoleData,
  degreeDepartment,
  studentRating,
  setStudentRating,
  setDegreeDepartmentData,

  setDegreeDepartment,
  candidateRangeMin = 0,
  setCandidateRangeMin,
  candidateRangeMax = 0,
  setCandidateRangeMax,
  rolesDegreeList,
  locationStatus,
  setLocationStatus,
  locationWiseFilterHanlder,
  prefferedlocationStatus,
  setPrefferedLocationStatus,

  setPrefferedLocations,
  setCurrentLocationStatus,
  setCitySave,
}) => {
  const [ratingOption, setRatingOption] = useState([])

  useEffect(() => {
    const ratings = []
    for (let i = 0.5; i <= 4.5; i += 0.5) {
      ratings.push({
        name: (
          <RatingFlex alignCenter>
            <div>{`Above ${i.toFixed(1)}`}</div>
            <GreenStarIcon />
          </RatingFlex>
        ),
        value: `${i.toFixed(1)}`,
      })
    }
    setRatingOption(ratings)
  }, [])

  const onDegreeChangeHandler = (keys, info) => {
    setDegreeDepartment(keys)
    setDegreeDepartmentData(info)
  }

  useEffect(() => {
    if (!applyFilter) {
      setErrors({ ...errors, filterError: '' })
    }

    if ((applyFilter && studentRating != '') || degreeDepartment != '') {
      setErrors({ ...errors, filterError: '' })
    }
  }, [applyFilter, studentRating, degreeDepartment])

  const filterOnClick = e => {
    setApplyFilter(false)
    setStudentRating('')

    setDegreeDepartment('')
    setDegreeDepartmentData([])
    setLocationStatus([])
    setPrefferedLocationStatus(false)
    setPrefferedLocations([])
    setCurrentLocationStatus(false)
  }

  const onCityChange = value => {
    setCitySave(value)
    setPrefferedLocations(value)
    if (!value?.length) {
      const updatedItems = locationStatus.filter(
        item => item !== 'PREFFERED_LOCATION'
      )

      setPrefferedLocationStatus(!prefferedlocationStatus)
      setLocationStatus(updatedItems)
    }
  }

  return (
    <Fragment>
      <RoleWrapper>Role</RoleWrapper>
      <ShortListDiv>
        <ShortListFlex alignCenter>
          <RoleNameDiv>{singleRoleData?.tittle}</RoleNameDiv>
          <RoleStatus status={singleRoleData?.status} />
        </ShortListFlex>
      </ShortListDiv>
      <DividerStyle />
      <Flex column style={{ marginTop: '-13px' }}>
        <ShortListDiv>Shortlist Candidates</ShortListDiv>
        <ShortListCanDiv>
          Select all the candidates or apply filters to shortlist candidates
        </ShortListCanDiv>
      </Flex>
      <ToggleDiv>
        <Toggle
          left="All Applied Candidates"
          right="Apply Filter"
          initialValue={applyFilter ? 'right' : 'left'}
          onClick={e => (e === true ? setApplyFilter(e) : filterOnClick())}
        />
      </ToggleDiv>
      <RedText>{errors?.filterError}</RedText>

      {applyFilter && (
        <div>
          <FormItem name={'ratings'}>
            <Select
              allowClear
              label="Ratings"
              placeholder="Select"
              OptionData={ratingOption}
              valueParam={'value'}
              value={studentRating}
              onChange={value => setStudentRating(value)}
              filterOption={(inputValue, option) => {
                const optionName = option['value'].toString().toLowerCase()
                const inputValueLower = inputValue.toLowerCase()
                return optionName.indexOf(inputValueLower) >= 0
              }}
            />
          </FormItem>
          <FormItem name={'candidateYear'}>
            <Label>Experience</Label>
            <Flex alignCenter>
              <CustomRangeSlider
                minValue={candidateRangeMin}
                setMinValue={setCandidateRangeMin}
                maxValue={candidateRangeMax}
                setMaxValue={setCandidateRangeMax}
                min={0}
                max={5}
                step={0.1}
              />

              <AntdInputStyle
                disabled
                placeholder={
                  candidateRangeMin + '-' + candidateRangeMax + ' ' + 'yrs'
                }
              />
            </Flex>
          </FormItem>
          <FormItem name={'degreeDepartment'}>
            <Label>Degree and department</Label>
            <TreeSelect
              id="previewDriveFilter"
              showSearch
              treeData={rolesDegreeList}
              treeCheckable={true}
              placeholder="Select"
              maxTagCount={5}
              onChange={onDegreeChangeHandler}
              treeNodeFilterProp="title"
              autoClearSearchValue={false}
              height="auto"
            />
          </FormItem>
          <FormItem>
            <StyledGroup
              options={[
                {
                  label: 'Preferred Location',
                  value: 'PREFFERED_LOCATION',
                  hidden: !singleRoleData?.cities?.length,
                },
                {
                  label: 'Current Location',
                  value: 'CURRENT_LOCATION',
                  hidden: !singleRoleData?.cities?.length,
                },
              ].filter(item => !item.hidden)}
              value={locationStatus}
              onChange={checkedValues =>
                locationWiseFilterHanlder(checkedValues)
              }
            />
          </FormItem>
          {prefferedlocationStatus && singleRoleData?.cities && (
            <FormItem name={['prefferedLocation']}>
              <Select
                showSearch={true}
                showArrow={true}
                OptionData={singleRoleData?.cities || []}
                label="Preferred Location *"
                placeholder="Select Preferred Location"
                mode={'multiple'}
                valueParam="name"
                onChange={value => onCityChange(value)}
                filterOption={false}
              />
            </FormItem>
          )}
        </div>
      )}

      <AddClgDiv>
        <ShortlistFlex
          background={
            appliedCandidatesListTrue?.result?.length > 0
              ? '#eff8f4'
              : COLORS.RED_T_92
          }
        >
          <GroupPeopleIcon
            color={
              appliedCandidatesListTrue?.result?.length > 0 ? '#5DB594' : 'red'
            }
          />
          {appliedCandidatesListTrue?.count ? (
            <ShortlistDiv>
              {appliedCandidatesListTrue?.result?.length}&nbsp;
              {appliedCandidatesListTrue?.result?.length == '1'
                ? 'candidate'
                : 'candidates'}
              &nbsp; shortlisted for this drive.
            </ShortlistDiv>
          ) : (
            <ShortlistDiv>
              No candidates shortlisted for this drive.
            </ShortlistDiv>
          )}
        </ShortlistFlex>
      </AddClgDiv>
    </Fragment>
  )
}

export default AddUserForm
